module.exports = {
	baseURL: "/",
	baseRoute: "/*",
	version: "e47b223",
	host: "https://chemnet.berkeley.edu/chemnet",
	reactHost: "https://chemnet.berkeley.edu",
}
